<template>
	<modal
		class="integration-modal"
		size="medium"
		@close="close">
		<template slot="header">
			<h3>
				<i class="material-icons">upload</i>
				<span>{{ $t('Import Products') }}</span>
			</h3>
		</template>
		<template slot="body">
			<div class="form-control mb-4">
				<input type="file" @change="onSelectFile">
			</div>
			<!-- Belum ada halaman tutorial untuk mengimpor produk -->
			<!-- <div class="mb-3">
				<a :href="tutorialLink" target="_blank">{{ $t('How to Import Products') }}</a>
			</div> -->
			<div class="mb-3">
				<a :href="exampleLink" target="_blank">{{ $t('Download Example') }}</a>
			</div>
			<div v-if="isUpdating">
				<div class="mb-2">
					<!-- <div class="mb-1">
						<span>{{ $t('Total Rows') }} :</span>
						<span>{{ totalRows }}</span>
					</div> -->
					<div class="">
						<span>{{ $t('Total Valid Products') }} :</span>
						<span>{{ totalValidProducts }}</span>
					</div>
				</div>
				<div class="mb-2">
					<span class="text-bold mr-2">{{ $t('Import Progress') }}</span>
					<span>{{ totalInserted }} / {{ totalValidProducts }}</span>
				</div>
				<progress-bar
					:label="$t('Import Progress')"
					:value="progress"
					:show-label="true"
				/>
			</div>
		</template>
		<template slot="footer">
			<button
				type="button"
				class="btn btn-default"
				:disabled="isSaving"
				@click="close">
				{{ $t('Cancel') }}
			</button>
			<button
				type="button"
				class="btn btn-primary"
				:class="{ 'is-loading': isSaving }"
				:disabled="!isFormValid"
				@click="startReadFile">
				{{ $t('Start') }}
			</button>
		</template>
	</modal>
</template>

<script>
import readXlsxFile from 'read-excel-file';
import Modal from '@/components/Modal.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import productsApi from '@/api/products';
import bgProcessApi from '@/api/background-process';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'ProductsImportModal',
	components: {
		Modal,
		ProgressBar,
	},
	data() {
		return {
			file: null,
			rows: [],
			items: [],
			idColIndex: 0,
			statusColIndex: 1,
			withdrawals: [],
			exampleLink: 'https://cdn.ostock.id/templates/Ostock-Import-Product-Template-v1.xlsx',
			tutorialLink: 'https://help.ostock.id/mengimpor-produk/',
			isSaving: false,
			isUpdating: false,
			totalRows: 0,
			totalInserted: 0,
			interval: null,
			startRow: 6,
			totalValidProducts: 0,
		};
	},
	sockets: {
		product_add() {
			this.totalInserted++;
			if (this.totalInserted === this.totalValidProducts) {
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Product Import',
					text: 'All products has been imported, please refresh the page',
				});
				this.close();
			}
			// this.add(product);
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		onSelectFile(event) {
			const files = event.target.files;
			if (files.length > 0) {
				this.isSubmitting = true;
				const file = files[0];
				this.file = file;
			}
		},
		startReadFile() {
			this.isSaving = true;
			readXlsxFile(this.file).then(this.processRows);
		},
		processRows(rows) {
			const firstRow = rows[0];
			const startIndex = firstRow && firstRow[0] === 'SKU' ? 1 : 4;

			const productRows = rows.slice(startIndex, rows.length);

			this.rows = productRows;
			this.totalRows = productRows.length;

			const filter = (product) => {
				const isValid = product[0] && product[0] !== '' // sku
					&& product[1] && product[1] !== '' // name
					&& product[2] && product[2] !== '' // price
					&& product[3] && product[3] !== '' // weight
					&& product[5] && product[5] !== '' // stock
					&& product[8] && product[8] !== ''; // image 1
				return isValid;
			};

			const validRows = productRows.filter(filter);

			this.totalValidProducts = validRows.length;
			this.startRow = startIndex;

			const maxRows = 1002;

			if (this.totalValidProducts > maxRows) {
				this.$notify({
					group: 'app',
					type: 'warning',
					title: 'Product Import',
					text: 'Max 1000 products per import',
				});
				this.isSaving = false;
			} else if (this.totalValidProducts === 0) {
				this.$notify({
					group: 'app',
					type: 'warn',
					title: 'Product Import',
					text: 'No valid products on the selected file, please fill the required columns',
				});
				this.isSaving = false;
			} else {
				this.submit();
			}
		},
		submit() {
			this.isSaving = true;
			this.isUpdating = true;

			const params = new FormData();
			params.append('file', this.file);
			params.append('start_row', this.startRow);

			const callback = (response) => {
				const responseData = response.data;
				console.log(responseData);

				// this.fetchProgress();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				console.log(message);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t('Product Import'),
					text: message,
				});
				this.isSaving = false;
				this.isUpdating = false;
			};
			productsApi.bulkCreate(params, callback, errorCallback);
		},
		// initSocketSub() {
		// 	this.$socket.$subscribe('product_add', (payload) => {
		// 		console.log(payload);
		// 	});
		// },
		fetchProgress() {
			const interval = setInterval(() => {
				this.getProgress();
			}, 1000);
			this.interval = interval;
		},
		getProgress() {
			const params = {
				type: 'product_create',
			};

			const callback = (response) => {
				const bgProcess = response.data;
				const completed = bgProcess.completed;
				this.totalInserted = completed;

				// Check if finish
				if (this.totalInserted >= this.totalValidProducts) {
					clearInterval(this.interval);
					this.close();
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Product Import',
						text: 'All products has been imported, please refresh the page',
					});
				}
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			bgProcessApi.getLast(params, callback, errorCallback);
		},
	},
	computed: {
		isFormValid() {
			return this.file;
		},
		progress() {
			const progress = this.totalInserted / this.totalValidProducts;
			const percentage = parseInt(progress * 100);
			return percentage;
		},
	},
	created() {
		// this.initSocketSub();
	},
};
</script>
